import { createSlice, createAsyncThunk, createEntityAdapter, current } from "@reduxjs/toolkit";
import { envAwarePost, envAwareFormSubmit } from "../util/util";
import moment from "moment";


export const getAllPosts = createAsyncThunk(
    "getAllPosts",
    async () => (envAwarePost("/api/posts/api",
        { action: "getAllPosts" }
    ))
)

export const requestOfficialBlog = createAsyncThunk(
    "requestOfficialBlog",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const getPostById = createAsyncThunk(
    "getPostById",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const deletePost = createAsyncThunk(
    "deletePost",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const createEditPost = createAsyncThunk(
    "createEditPost",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const getAllCommentsByPostId = createAsyncThunk(
    "getAllCommentsByPostId",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const getAllActivePostsByAddress = createAsyncThunk(
    "getAllActivePostsByAddress",
    async (payload) => (envAwarePost("publicPosts.php", payload))
)

export const getSinglePost = createAsyncThunk(
    "getSinglePost",
    async (payload) => (envAwarePost("publicPosts.php", payload))
)

export const createComment = createAsyncThunk(
    "createComment",
    async (payload) => (envAwarePost("/api/posts/api", payload))
)

export const getTrainerId = createAsyncThunk(
    "getTrainerId",
    async (payload) => (envAwarePost("publicPosts.php", payload))
)

export const getPostSearchResults = createAsyncThunk(
    "getPostSearchResults",
    async (payload) => (envAwarePost("publicPosts.php", payload))
)

export const getPostComments = createAsyncThunk(
    "getPostComments",
    async (payload) => (envAwarePost("publicPosts.php", payload))
)

export const getPageAddress = createAsyncThunk(
    "getPageAddress",
    async () => (envAwarePost("/api/posts/api",
    {action:"getPageAddress"}))
)

const postAdapter = createEntityAdapter({
    selectId: ent => ent.post_id,
})

const postActiveAdapter = createEntityAdapter({
    selectId: ent => ent.post_id,
})


const blogSlice = createSlice({
    name: "blogSlice",
    initialState: {
        postList: postAdapter.getInitialState(),
        postListLoading: false,
        postListActive: postActiveAdapter.getInitialState(),
        trainerId: "",
        singlePost: {post_body : ""},
        searchResults : [],
        searched : "",
        getSinglePostLoading : false,
        postComments : [],
        getCommentsLoading : false,
    },
    reducers: {
        addPostSearch : (state, action) => {
            state.searched = action.payload.searched;
        }
    },

    extraReducers: {
        [getAllPosts.pending]: (state, action) => {
            state.postListLoading = true;
        },
        [getAllPosts.fulfilled]: (state, action) => {
            state.postListLoading = false;
            const { data, success } = action.payload;
            if (success === "1") {
                if (data) { 
                    postAdapter.setAll(state.postList, data)
                }
            }
        },
        [deletePost.fulfilled]: (state, action) => {
            const { data, success } = action.payload;
            const post_id = data.post_id;
            if (success === "1") {
                postAdapter.removeOne(state.postList, post_id)
            }
        },
        [getAllActivePostsByAddress.pending]: (state, action) => {
            state.postListLoading = true;
        },
        [getAllActivePostsByAddress.fulfilled]: (state, action) => {
            state.postListLoading = false;
            const { data, success } = action.payload;
            let activePosts = data.activePosts
            if (success === "1") {
                postActiveAdapter.setAll(state.postListActive, activePosts)
            }

        },
        [getTrainerId.fulfilled]: (state, action) => {
            const { data, success } = action.payload;
            let trainerId = data.trainer_id
            if (success === "1") {
                state.trainerId = trainerId;
            }

        },
        [getSinglePost.pending]: (state, action) => {
            state.getSinglePostLoading = true;
        },
        [getSinglePost.rejected]: (state, action) => {   
           state.getSinglePostLoading = false;
        },
        [getSinglePost.fulfilled]: (state, action) => {
            state.getSinglePostLoading = false;
            const { data, success } = action.payload;
            if (success === "1") {
                state.singlePost = data.post
                
            }
        },
        [getPostComments.pending]: (state, action) => {
            state.getCommentsLoading = true;
        },
        [getPostComments.fulfilled]: (state, action) => {
            const { data, success } = action.payload;
            state.getCommentsLoading = false;
            if (success === "1") {
                state.postComments = data.post_comments
                
            }
        },
        [getPostSearchResults.fulfilled]: (state, action) => {
            const { data, success } = action.payload;
            if (success === "1") {
                state.searchResults = data.searchResults
            }
        }, 
        [createComment.fulfilled]: (state, action) => {
            let date_added = new Date()
            date_added = moment(date_added).format("MMM DD, YYYY")
            let comment = {comment:action.meta.arg.comment, user_name: action.meta.arg.user_name, date_added  }
            state.postComments = [comment ,...state.postComments]
        },
    },
});

export const {
    selectAll: selectAllPosts,
    selectById: selectPostsById,
    selectIds: selectPostIds
} = postAdapter.getSelectors(state => state.posts.postList)

export const {
    selectAll: selectAllActivePosts,
    selectById: selectActivePostsById,
    selectIds: selectActivePostIds
} = postActiveAdapter.getSelectors(state => state.posts.postListActive)


export const { addPostSearch } = blogSlice.actions;

export default blogSlice.reducer;